export default [
    {
        path: "/training/group-training",
        component: () => import("@/App/Training/GroupTraining/Components/List.vue"),
        name: "training-group-training-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/group-training/create",
        component: () => import("@/App/Training/GroupTraining/Components/Create.vue"),
        name: "training-group-training-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/group-training/detail-list",
        component: () => import("@/App/Training/GroupTraining/Components/DetailList.vue"),
        name: "training-group-training-detail-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/group-training/detail",
        component: () => import("@/App/Training/GroupTraining/Components/DetailCreate.vue"),
        name: "training-group-training-detail",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/group-training/detail-edit/:id",
        component: () => import("@/App/Training/GroupTraining/Components/DetailEdit.vue"),
        name: "training-group-training-edit",
        meta: {
            requiresAuth: true,
        },
    },
];
